module.exports = __webpack_public_path__ + "static/media/paragon_4.11ff3958.png";